import ActionCable from 'actioncable'
import tokenStorage from '../token-storage'

const setConsumerUrl = (apiBaseUrl, token) => {
  const matchData = apiBaseUrl.match(/https?/)
  const socketProtocol = /localhost/.test(apiBaseUrl) ? 'ws' : 'wss'

  const socketUrl = matchData ?
    apiBaseUrl.replace(matchData[0], socketProtocol) :
    socketProtocol + apiBaseUrl

  return `${socketUrl}/cable?token=${token}`
}

const createConsumer = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL
  const token = tokenStorage.get()
  const socketUrl = setConsumerUrl(apiBaseUrl, token)
  return ActionCable.createConsumer(socketUrl)
}

export default (channelName, componentInterface) => {
  const consumer = createConsumer()

  return consumer
    .subscriptions
    .create(channelName, componentInterface)
}



// WEBPACK FOOTER //
// ./src/services/socket/index.js